import type {
  SavedDashboardList,
  SelectedVoiceCallFilterColumnsData,
} from 'src/types/analytics-genesis';
import type {AnalyticsVoiceCallAction} from 'src/action-creators/analytics/analytics-voice-call';
import {
  RECEIVE_SAVED_DASHBOARDS,
  SET_NAVIGATION_DOWN,
  SET_NAVIGATION_UP,
  RECEIVE_ALL_VOICEFLOWS_TABLE_COLUMN_SELECTION,
  RECEIVE_ALL_WORKFLOWS_TABLE_COLUMN_SELECTION,
  RECEIVE_ALL_CALL_RECORDS_TABLE_COLUMN_SELECTION,
} from 'src/action-creators/analytics/analytics-voice-call';


export type AnalyticsVoiceCallState = {
  savedDashboards: SavedDashboardList | null;
  isNavigationDown: boolean | null;
  isNavigationUp: boolean | null;
  allVoiceflowsTableColumnFilterData: SelectedVoiceCallFilterColumnsData | null;
  allWorkflowsTableColumnFilterData: SelectedVoiceCallFilterColumnsData | null;
  allCallRecordsTableColumnFilterData: SelectedVoiceCallFilterColumnsData | null;
};

const initialState: AnalyticsVoiceCallState = {
  savedDashboards: null,
  isNavigationDown: null,
  isNavigationUp: null,
  allVoiceflowsTableColumnFilterData: null,
  allWorkflowsTableColumnFilterData: null,
  allCallRecordsTableColumnFilterData: null,
};

const analyticsVoiceCallReducer = (
  state: AnalyticsVoiceCallState = initialState,
  action: AnalyticsVoiceCallAction,
): AnalyticsVoiceCallState => {
  switch (action.type) {
    case RECEIVE_SAVED_DASHBOARDS:
      return {
        ...state,
        savedDashboards: action.payload,
      };

    case SET_NAVIGATION_DOWN:
      return {
        ...state,
        isNavigationDown: action.payload,
      };

    case SET_NAVIGATION_UP:
      return {
        ...state,
        isNavigationUp: action.payload,
      };

    case RECEIVE_ALL_VOICEFLOWS_TABLE_COLUMN_SELECTION:
      return {
        ...state,
        allVoiceflowsTableColumnFilterData: action.payload,
      };

    case RECEIVE_ALL_WORKFLOWS_TABLE_COLUMN_SELECTION:
      return {
        ...state,
        allWorkflowsTableColumnFilterData: action.payload,
      };

    case RECEIVE_ALL_CALL_RECORDS_TABLE_COLUMN_SELECTION:
      return {
        ...state,
        allCallRecordsTableColumnFilterData: action.payload,
      };

    default:
      return state;
  }
};

export default analyticsVoiceCallReducer;
